// extracted by mini-css-extract-plugin
export default {"icon":"sports_icon__a-lIo","iconDanger":"sports_iconDanger__RLdrn"};